import { type FC } from 'react';
import { ToastProvider } from '@heroui/react';

// Native HeroUI positioning: top-center, offset below the ~75px app header so toasts don't
// overlap it (mirrors where the legacy ngToast appeared). HeroUI's own horizontal centering for
// this placement didn't take effect via the provider, so the card is centered explicitly with
// `mx-auto` in showToast's classNames instead.
/*
    HeroUI puts the toast region at z-[100], which is under MUI's default 1300 modal layer, so a
    toast fired from inside a MUI dialog rendered behind it and was invisible. 1301 clears the
    dialog and deliberately stops short of the 1350 that GooglePlaces.scss claims with !important,
    so an address autocomplete still wins over a toast.
*/
export const AppToastProvider: FC = () => (
    <ToastProvider
        placement="top-center"
        maxVisibleToasts={3}
        toastOffset={80}
        regionProps={{ className: 'z-[1301]' }}
    />
);
